import { HiOutlineDocumentText } from "react-icons/hi2";
import { ResumeItem } from "./ResumeItem";
import { ResumeUploadArea } from "./ResumeUploadArea";
import styles from "../ResumePage.module.css";

export const ResumeList = ({
  uploadedFiles,
  uploadingFiles,
  uploadErrors,
  selectedFileId,
  searchCache,
  searchingFile,
  isInitialLoading,
  onFileSelect,
  onSelectFile,
  onRemoveFile,
}) => {
  return (
    <div className={styles.leftSection}>
      <div className={styles.sectionHeader}>
        <HiOutlineDocumentText className={styles.sectionIcon} />
        <h2>Your Resumes</h2>
        {searchingFile && <span className={styles.searchingCount}>Searching...</span>}
      </div>

      <ResumeUploadArea onFileSelect={onFileSelect} />

      <div className={styles.fileList}>
        {isInitialLoading ? (
          <div className={styles.emptyState}>
            <div className={styles.loadingSpinnerSmall}></div>
            <p>Loading resumes...</p>
          </div>
        ) : uploadedFiles.length === 0 ? (
          <div className={styles.emptyState}>
            <p>No resumes available</p>
          </div>
        ) : (
          uploadedFiles.map((file) => {
            const cache = searchCache[file.id];
            const isFileSearching = searchingFile === file.id;
            const isUploading = uploadingFiles[file.id] !== undefined;
            const hasResults = cache && cache.results && cache.results.length > 0 && !cache.error;

            return (
              <ResumeItem
                key={file.id}
                file={file}
                isSelected={selectedFileId === file.id}
                isUploading={isUploading}
                progress={uploadingFiles[file.id] || 0}
                error={uploadErrors[file.id]}
                hasSearchResults={hasResults}
                isSearching={isFileSearching}
                onSelect={onSelectFile}
                onRemove={onRemoveFile}
              />
            );
          })
        )}
      </div>
    </div>
  );
};